const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  bundleItemAdded: 'td-bundle-added',
  bundleItemRemoved: 'td-bundle-removed',
  bundleFiltered: 'td-bundle-filtered',
  bundleFacetChanged: 'td-bundle-facet-changed',
  bundleFilled: 'td-bundle-filled',
  bundleOpen: 'td-bundle-open',
  bundlePromptAdded: 'td-bundle-prompt-added',
  bundleProductAdded: "td-bundle-product-added",
  bundleProductRemoved: "td-bundle-product-removed",
  bundleDiscountSet: 'td-bundle-discount-set',
  bundleTierActivate: "td-bundle-tier-activate",
  bundleTierDeactivate: 'td-bundle-tier-deactivate',
  bundleGiftRevoked: 'td-bundle-gift-removed',
  bundleGiftGranted: 'td-bundle-gift-added',
  bundleAdded: 'td-bundle-added',
  bundleEmptied: 'td-bundle-emptied'
};
